export default __webpack_public_path__ + "static/media/Websites-Facebouk.187b5120.png";